module.exports = __webpack_public_path__ + "img/Shiba-BG.cf813bc1.jpg";